import { toast } from "react-toastify";
import api from "../axiosInstance";

export const emailVerification = async (payload) => {
    try {
      const response = await api.post("/forgot",payload);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.statusCode === 400) {
        toast.error("Email not register");
        throw error;
      } else {
        toast.error("Something went wrong");
        throw error;
      }
    }
};


export const otpVeri = async (payload) =>{
  try{
    const response = await api.post("/verifyOTP",payload);
    return response.data;
  }catch(error){
      toast.error("Something went wrong");
      throw error;
  }
}

export const setNewPassword = async (payload) =>{
  try{
    const response = await api.post("/resetPassword",payload);
    return response.data;
  }catch(error){
    // if(error?.response?.data?.statusCode === 400){
    //   toast.error("No user with this email");
    // }else{
      toast.error("Something went wrong");
      throw error;
    // }
  }
}